import React, { useEffect, useState } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import { usePreCheckInContext } from "./contexts/PreCheckInContext";
import { get, isEmpty } from "lodash";
import Mustache from "mustache";
import { convertToAmPm } from "../../utils/timeUtils";

const Confirmation = () => {
  const { t } = useTranslation();
  const [primaryGuest, setPrimaryGuest] = useState(null);
  const [isPageMounted, setIsPageMounted] = useState(true);
  const {
    propertyUid,
    language,
    data: { presets, property, configuration, guestService, booking, guests },
    components: { PreCheckInHeader, PreCheckInContainer },
  } = usePreCheckInContext();

  useEffect(() => {
    if (guests && !primaryGuest) {
      setIsPageMounted(false);
      setPrimaryGuest(guests.allGuests()[0]);
      return () => {};
    }
  }, [isPageMounted, guests, primaryGuest, presets]);

  useEffect(() => {
    const tabletContainer = document.getElementById("tablet-container");
    if (tabletContainer && presets) {
      if (!isEmpty(presets.backgroundColorTopBar)) {
        tabletContainer.style.backgroundColor = presets.backgroundColorTopBar;
      }
    }
  }, [presets]);

  const goBack = () => {
    let url;
    if (!isEmpty(guestService.storeUrl)) {
      url = guestService.storeUrl;
    } else if (!isEmpty(property.website)) {
      url = property.website;
    } else {
      url = `/pre-checkin/${propertyUid}/home?language=${language}`;
    }
    window.location.href = url;
  };

  const isSixSenses = property?.brand?.name === "Six Senses";
  const fontClass = isSixSenses ? "six-senses-font" : "";
  
  setTimeout(() => {
    const fontStyle = 'font-family: AvenirNext-Regular, sans-serif !important;';
    const appliedClass = 'applied-six-senses-font';
  
    const applyFontStyle = (elements) => {
      elements.forEach(el => {
        if (!el.classList.contains(appliedClass)) {
          const currentStyle = el.getAttribute('style') || '';
          el.setAttribute('style', `${currentStyle}; ${fontStyle}`);
          el.classList.add(appliedClass);
        }
      });
    };
  
    const sixSensesElements = document.querySelectorAll('.six-senses-font');
    sixSensesElements.forEach(el => {
      applyFontStyle([el]);
      el.classList.remove('six-senses-font');
    });
  
    const section = document.querySelector('.copyright-section');
    if (section) {
      const targets = section.querySelectorAll('ul > li > div, ul > li > div > span, ul > li > div > span > a');
      applyFontStyle(targets);
    }
  }, 500);

  return (
    <PreCheckInContainer containerName="confirmation" className={fontClass}>
      <PreCheckInHeader title={t("REQUEST_COMPLETED", "REQUEST COMPLETED")} />
      {booking && (
        <>
          <section
            id="content"
            className="relative flex flex-col px-10 w-full flex-1 md:flex-0 pt-20"
            style={{ backgroundColor: presets.backgroundColorTopBar }}>
            <div className="w-full">
              <div className="md:max-w-4xl mx-auto w-full bg-white rounded-3xl p-10 mb-8">
                <div className="flex flex-col justify-center h-full">
                  <div className="flex mb-5 w-full">
                    <div
                      className="mr-8 w-16 h-16 rounded-full overflow-hidden flex items-center"
                      style={{
                        backgroundColor: presets.backgroundColorTopBar,
                      }}>
                      {property.property_system_icon && (
                        <img
                          className="w-full"
                          src={property.property_system_icon}
                          alt={t("HOTEL_LOGO", "Hotel Logo")}
                        />
                      )}
                    </div>

                    <div className={`capitalize font-normal ${fontClass}`}>
                      <h1
                        className={`mb-4 type-title normal ${fontClass}`}
                        style={{ color: presets.titleColor }}>
                        {property.name}
                      </h1>
                      <p
                        className={`mb-2 type-regular normal ${fontClass}`}
                        style={{ color: presets.subtitleColor }}>
                        {get(booking, "room_description")}
                      </p>
                      <p
                        className={`mb-2 mb-10 type-regular normal ${fontClass}`}
                        style={{ color: presets.subtitleColor }}>
                        {t("BOOKING_NUMBER", "Booking Number")}{" "}
                        <span className={`type-title medium ${fontClass}`}>
                          {get(booking, "booking_id")}
                        </span>
                      </p>

                      <p
                        className={`text-14 type-regular normal ${fontClass}`}
                        style={{ color: presets.subtitleColor }}>
                        {configuration.checkPreCheckInInterfaceTypeIsHotelKey
                          ? t("BEDS", "Beds")
                          : t("ROOMS")}
                        :
                        <span className={`type-title medium pl-1 ${fontClass}`}>
                          {get(booking, "number_of_rooms")}
                        </span>{" "}
                        |{" "}
                        {configuration.checkPreCheckInInterfaceTypeIsHotelKey
                          ? t("MAX_GUESTS", "Max Guests")
                          : t("GUESTS")}
                        :
                        <span className={`type-title medium ${fontClass}`}>
                          {" "}
                          {get(booking, "total_guests")}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div className={`capitalize font-normal flex w-full mb-7 ${fontClass}`}>
                    <div className="flex flex-1 justify-end">
                      <div className="flex flex-col space-y-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-9 h-9 mx-auto"
                          viewBox="0 0 448 512">
                          <path
                            fill={`${presets.backgroundColorTopBar}`}
                            d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path>
                        </svg>
                        <p
                          className={`text-okkami-gray font-normal text-center type-regular medium uppercase ${fontClass}`}
                          style={{ color: presets.subtitleColor }}>
                          {t("CHECK_IN", "CHECK-IN")}
                        </p>
                        <p
                          className={`text-okkami-dark-gray text-center type-title normal ${fontClass}`}
                          style={{ color: presets.titleColor }}>
                          {booking.checkInDateText}
                        </p>
                        <p
                          className={`type-normal normal text-center ${fontClass}`}
                            style={{ color: presets.titleColor }}>
                          {`${t("BEGINS_AT", "")} ${
                            presets.amPm
                              ? convertToAmPm(configuration.checkInTimeText)
                              : configuration.checkInTimeText
                          }`}
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-center items-center mx-5">
                      <svg
                        className="w-7 h-7 mx-auto"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512">
                        <path
                          fill={`${presets.backgroundColorTopBar}`}
                          d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
                      </svg>
                    </div>
                    <div className="flex flex-1 justify-start">
                      <div className="flex flex-col space-y-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-9 h-9 mx-auto"
                          viewBox="0 0 448 512">
                          <path
                            fill={`${presets.backgroundColorTopBar}`}
                            d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path>
                        </svg>
                        <p
                          className={`text-okkami-gray font-normal text-center type-regular medium uppercase ${fontClass}`}
                          style={{ color: presets.subtitleColor }}>
                          {t("CHECK_OUT", "CHECK-OUT")}
                        </p>
                        <p
                          className={`text-okkami-dark-gray text-center type-title normal ${fontClass}`}
                          style={{ color: presets.titleColor }}>
                          {booking.checkOutDateText}
                        </p>
                        <p
                          className={`type-normal normal text-center ${fontClass}`}
                          style={{ color: presets.titleColor }}>
                          {presets.amPm
                            ? convertToAmPm(configuration.checkOutTimeText)
                            : configuration.checkOutTimeText}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className={`type-regular large text-center leading-10 text-okkami-min-shaft-2 ${fontClass}`}>
                    {guestService.confirmMessageDescription &&
                      primaryGuest &&
                      Mustache.render(guestService.confirmMessageDescription, {
                        title: primaryGuest.title,
                        firstName: primaryGuest.firstName,
                        lastName: primaryGuest.lastName,
                      })
                        .split("\n")
                        .map((line, index) =>
                          line.length > 0 ? (
                            <p className={fontClass} key={index}>{line}</p>
                          ) : (
                            <p className={fontClass} key={index} dangerouslySetInnerHTML={{ __html: "&nbsp;" }} />
                          )
                        )}
                    </div>
                  </div>
                </div>
              </div>
              {guestService.enableDisplayOfCheckInTime && (
                <div className="flex flex-col">
                  <p className={`py-4 uppercase text-white type-normal xxLarge mb-2 text-center ${fontClass}`}>
                    {t("CHECK_IN_TIME", "CHECK-IN TIME")}
                  </p>
                  <p className={`py-4 text-white type-normal xxxxLarge text-center ${fontClass}`}>
                    {`${t("BEGINS_AT", "")} ${
                      presets.amPm
                        ? convertToAmPm(configuration.checkInTimeText)
                        : configuration.checkInTimeText
                    }`}
                  </p>
                </div>
              )}
              <button
                className={`app-button-ipad type-title medium ${presets.buttonStyleName} ${fontClass}`}
                style={{
                  backgroundColor: presets.backgroundColorTopBar,
                  color: presets.appHomeTextCallToAction,
                }}
                onClick={() => goBack()}>
                {guestService.callToActionText || t("EXIT")}
              </button>
            </div>
          </section>
          <button
            className={`app-button-mobile type-title medium ${fontClass}`}
            style={{
              backgroundColor: presets.backgroundColorTopBar,
              color: presets.appHomeTextCallToAction,
            }}
            onClick={() => goBack()}>
            {guestService.callToActionText || t("EXIT")}
          </button>
        </>
      )}
    </PreCheckInContainer>
  );
};
export default withTranslation()(Confirmation);
